import {
  jwtAuthAxios,
  optionalAuthAxios,
} from "../../shared/utils/network-utils";
import {
  CreateSimulationWay,
  SimulationWay,
  UpdateSimulationWay,
} from "../models/SimulationWay";

const prefix = "/simulation-ways";

export const SimulationWayApi = {
  update: async (simulationWayId: string, body: UpdateSimulationWay) => {
    return await jwtAuthAxios().put<SimulationWay>(
      `${prefix}/${simulationWayId}`,
      body,
    );
  },
  createSimulated: async (body: CreateSimulationWay) => {
    return await jwtAuthAxios().post<SimulationWay>(`${prefix}`, body);
  },
  deleteSimulation: async (simulationWayId: string) => {
    return await jwtAuthAxios().delete(`${prefix}/${simulationWayId}`);
  },
  listHlaWayIdsBySurvey: async (surveyId: string) => {
    return await optionalAuthAxios().get<string[]>(
      `${prefix}/survey/${surveyId}/hla-way-ids`,
    );
  },
};
